import React from 'react';
import NetworkDashboard from '../components/NetworkDashboard';

const StatisticsPage: React.FC = () => {
  return <NetworkDashboard />;
};

export default StatisticsPage;